/**
 * Strip non-digit characters from a string. Use for normalizing numeric input
 * (e.g. pet count, currency fields) so only 0-9 are stored.
 */
export function stripNonDigits(value: string): string {
  return value.replace(/\D/g, '');
}
